"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationCognito = exports.ERROR_AUTHORIZATION_COGNITO_NO_ACTIVE_USER = exports.AuthorizationCognitoStorageDefault = void 0;
const amazon_cognito_identity_js_1 = require("amazon-cognito-identity-js");
const moment_1 = __importDefault(require("moment"));
const BasePlugin_1 = require("../base/BasePlugin");
exports.AuthorizationCognitoStorageDefault = {
    authorization: {
        isAuthCheckState: "idle",
        isAuth: false
    }
};
exports.ERROR_AUTHORIZATION_COGNITO_NO_ACTIVE_USER = new Error("AuthorizationCognitoNoActiveUser");
class AuthorizationCognito {
    constructor(parent, UserPoolId, UserPoolAppClient, Storage) {
        this.parent = parent;
        this.UserPoolId = UserPoolId;
        this.UserPoolAppClient = UserPoolAppClient;
        this.Storage = Storage;
        this.CognitoUserPool = new amazon_cognito_identity_js_1.CognitoUserPool({
            UserPoolId: this.UserPoolId,
            ClientId: this.UserPoolAppClient,
            Storage: this.Storage()
        });
    }
    get isAuth() {
        return this.parent.state.context.authorization.isAuth;
    }
    get isAuthCheckState() {
        return this.parent.state.context.authorization.isAuthCheckState;
    }
    login(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const cognitoUser = new amazon_cognito_identity_js_1.CognitoUser({
                    Username: username,
                    Pool: this.CognitoUserPool
                });
                cognitoUser.authenticateUser(new amazon_cognito_identity_js_1.AuthenticationDetails({
                    Username: username,
                    Password: password
                }), {
                    onSuccess: () => {
                        this.checkAuth();
                        resolve({ RequirePasswordChange: false });
                    },
                    onFailure: (error) => reject(error),
                    newPasswordRequired: (userAttributes, requiredAttributes) => {
                        resolve({
                            RequirePasswordChange: true,
                            SessionUserAttributes: userAttributes,
                            CognitoUser: cognitoUser
                        });
                    }
                });
            });
        });
    }
    setNewPassword(cognitoUser, newPassword, userAttributes) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                cognitoUser.completeNewPasswordChallenge(newPassword, [], {
                    onSuccess: () => {
                        this.checkAuth();
                        resolve();
                    },
                    onFailure: (e) => reject(e)
                });
            });
        });
    }
    register(email, password, userAttributes) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.CognitoUserPool.signUp(email, password, userAttributes || [], null, (error) => {
                    if (error) {
                        reject(error);
                        return;
                    }
                    resolve();
                });
            });
        });
    }
    resetPasswordSendCode(email) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const cognitoUser = new amazon_cognito_identity_js_1.CognitoUser({
                    Username: email,
                    Pool: this.CognitoUserPool
                });
                cognitoUser.forgotPassword({
                    onSuccess: () => resolve(),
                    onFailure: (error) => reject(error)
                });
            });
        });
    }
    resetPasswordSetNewPassword(email, code, newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const cognitoUser = new amazon_cognito_identity_js_1.CognitoUser({
                    Username: email,
                    Pool: this.CognitoUserPool
                });
                cognitoUser.confirmPassword(code, newPassword, {
                    onSuccess: () => resolve(),
                    onFailure: (error) => reject(error)
                });
            });
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const currentUser = yield this.getCurrentUser();
                currentUser.signOut();
                this.checkAuth();
            }
            catch (e) { }
        });
    }
    getToken() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.refreshToken();
            const session = yield this.getSession();
            return session.getAccessToken().getJwtToken();
        });
    }
    checkAuth() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.setIsAuthCheckState("pending");
                const session = yield this.getSession();
                const isValid = session.isValid();
                yield this.setStorage(() => ({
                    isAuth: isValid,
                    isAuthCheckState: "completed"
                }));
                return isValid;
            }
            catch (e) {
                if (e === exports.ERROR_AUTHORIZATION_COGNITO_NO_ACTIVE_USER) {
                    yield this.setStorage(() => ({
                        isAuth: false,
                        isAuthCheckState: "completed"
                    }));
                    return false;
                }
                yield this.setStorage(() => ({
                    isAuth: false,
                    isAuthCheckState: "completed"
                }));
                return false;
            }
        });
    }
    getSession() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentUser = yield this.getCurrentUser();
            return new Promise((resolve, reject) => {
                currentUser.getSession((error, session) => {
                    if (!!error) {
                        reject(error);
                    }
                    if (!!session) {
                        resolve(session);
                    }
                    reject();
                });
            });
        });
    }
    getCurrentUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentUser = this.CognitoUserPool.getCurrentUser();
            if (!currentUser) {
                throw exports.ERROR_AUTHORIZATION_COGNITO_NO_ACTIVE_USER;
            }
            return currentUser;
        });
    }
    refreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentUser = yield this.getCurrentUser();
            const session = yield this.getSession();
            if (session.getAccessToken().getExpiration() - moment_1.default().unix() < 120) {
                return new Promise((resolve, reject) => {
                    currentUser.refreshSession(session.getRefreshToken(), (error) => {
                        if (!!error) {
                            reject(error);
                        }
                        resolve();
                    });
                });
            }
            return;
        });
    }
    setStorage(stateFunction) {
        return __awaiter(this, void 0, void 0, function* () {
            return BasePlugin_1.ParentSetState(this.parent, "authorization", (storage) => stateFunction(storage));
        });
    }
    setIsAuthCheckState(state) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.setStorage((storage) => (Object.assign(Object.assign({}, storage), { isAuthCheckState: state })));
        });
    }
    setIsAuth(isAuth) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.setStorage((storage) => (Object.assign(Object.assign({}, storage), { isAuth: isAuth })));
        });
    }
}
exports.AuthorizationCognito = AuthorizationCognito;
//# sourceMappingURL=Cognito.js.map